import { Loadable } from 'shared/components'
import { ModuleRoute, UserRole } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: '/lawsuits',
    exact: true,
    component: Loadable({
      component: () => import('./pages/Lawsuits'),
    }),
    role: [UserRole.User],
  },
  {
    path: '/lawsuits/:id',
    exact: true,
    component: Loadable({
      component: () => import('./pages/LawsuitDetails'),
    }),
    role: [UserRole.User],
  },
  {
    path: '/lawsuits/:id/chat',
    exact: true,
    component: Loadable({
      component: () => import('./pages/LawsuitMessages'),
    }),
    role: [UserRole.User],
  },
  {
    path: '/lawsuits/:id/data-correction',
    exact: true,
    component: Loadable({
      component: () => import('./pages/LawsuitCorrection'),
    }),
    role: [UserRole.User],
  },
  {
    path: '/lawsuits/:id/bank-transfer',
    exact: true,
    component: Loadable({
      component: () => import('./pages/LawsuitBankTransfer'),
    }),
    role: [UserRole.User],
  },
  {
    path: '/lawsuits/:id/withdraw',
    exact: true,
    component: Loadable({
      component: () => import('./pages/LawsuitWithdraw'),
    }),
    role: [UserRole.User],
  },
  {
    path: '/lawsuits/:id/payment',
    exact: true,
    component: Loadable({
      component: () => import('./pages/LawsuitAdministrativePayment'),
    }),
    role: [UserRole.User],
  },
  {
    path: '/lawyer/lawsuits',
    exact: true,
    component: Loadable({
      component: () => import('./pages/LawyerLawsuits'),
    }),
    role: [UserRole.Lawyer],
  },
  {
    path: '/lawyer/lawsuits/:id',
    exact: true,
    component: Loadable({
      component: () => import('./pages/LawyerLawsuitDetails'),
    }),
    role: [UserRole.Lawyer],
  },
  {
    path: '/lawyer/lawsuits/:id/verification',
    exact: true,
    component: Loadable({
      component: () => import('./pages/LawyerLawsuitVerification'),
    }),
    role: [UserRole.Lawyer],
  },
  {
    path: '/lawyer/lawsuits/:id/lawsuit-data',
    exact: true,
    component: Loadable({
      component: () => import('./pages/LawyerLawsuitData'),
    }),
    role: [UserRole.Lawyer],
  },
  {
    path: '/lawyer/lawsuits/:id/verification/bank-transfer',
    exact: true,
    component: Loadable({
      component: () => import('./pages/LawyerLawsuitBankTransfer'),
    }),
    role: [UserRole.Lawyer],
  },
  {
    path: '/lawyer/lawsuits/:id/chat',
    exact: true,
    component: Loadable({
      component: () => import('./pages/LawyerLawsuitMessages'),
    }),
    role: [UserRole.Lawyer],
  },
  {
    path: '/lawsuits/new/circumstances',
    disableLayout: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/NewLawsuit/LawsuitCircumstances'),
    }),
    role: [UserRole.User],
  },
  {
    path: '/lawsuits/new/documents',
    disableLayout: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/NewLawsuit/LawsuitDocuments'),
    }),
    role: [UserRole.User],
  },
  {
    path: '/lawsuits/new/parties',
    disableLayout: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/NewLawsuit/LawsuitParties'),
    }),
    role: [UserRole.User],
  },
  {
    path: '/lawsuits/new/summary',
    disableLayout: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/NewLawsuit/LawsuitSummary'),
    }),
    role: [UserRole.User],
  },
  {
    path: '/lawsuits/new/success',
    disableLayout: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/NewLawsuit/LawsuitSuccess'),
    }),
    role: [UserRole.User],
  },
]

export default routes
